// 引入公共模块
import {
  throttle,
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    throttle();
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.versionHeaderHandler(); //版本顶部处理
    this.consultBtnHandler(); //咨询弹窗
  },
  versionHeaderHandler() {
    // 版本顶部处理
    $(window).on('scroll', throttle(function() {
      const versionHeader = $(".version-card");
      const scrollPosition = versionHeader.offset().top - $(window).scrollTop();
      if (scrollPosition < 70 ) {
        if (scrollPosition < -2450) {
          versionHeader.removeClass("scrolled");
        } else {
          versionHeader.addClass("scrolled");
        }        
      }
      else {
        versionHeader.removeClass("scrolled");
      }
    }, 20));
  },
  consultBtnHandler() {
    // 打开咨询弹窗
    $('.btn-consult').on('click', ()=> {
      $('.consult-modal').addClass('consult-modal-active');
      // 禁用页面滚动
      $('body').addClass('scroll-lock');
    });

    // 关闭咨询弹窗
    $('.consult-modal-close').on('click', ()=> {
      $('.consult-modal').removeClass('consult-modal-active');
      // 恢复页面滚动
      $('body').removeClass('scroll-lock');
    });
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
